/**
 * Service Level Objective Penalty Endpoints
 */

export const apiPostPenalty = async (
  penalty: ServiceLevelObjectivePenaltyCreateUpdate,
): Promise<AxiosResponse<ServiceLevelObjectivePenalty>> => {
  return await userManagementAxiosInstance.post('service_level_objective_penalties', penalty);
};

export const apiGetPenalties = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedServiceLevelObjectivePenalty>> => {
  return await userManagementAxiosInstance.get(
    `service_level_objective_penalties?limit=${limit}&offset=${offset}`,
  );
};

export const apiGetPenalty = async (
  id: string | number,
): Promise<AxiosResponse<ServiceLevelObjectivePenalty>> => {
  return await userManagementAxiosInstance.get(`service_level_objective_penalties/${id}`);
};

export const apiPutPenalty = async (
  penalty: ServiceLevelObjectivePenaltyCreateUpdate,
): Promise<AxiosResponse<ServiceLevelObjectivePenalty>> => {
  return await userManagementAxiosInstance.put(
    `service_level_objective_penalties/${penalty.id}`,
    penalty,
  );
};

export const apiDeletePenalty = async (
  id: string | number,
): Promise<AxiosResponse<ServiceLevelObjectivePenalty>> => {
  return await userManagementAxiosInstance.delete(`service_level_objective_penalties/${id}`);
};
